import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import axios from "axios";
import ListSubheader from "@mui/material/ListSubheader";
import { SelectChangeEvent } from "@mui/material";
import { Close } from "@mui/icons-material";

const SchoolRegisterFormModal = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [mosadName, setMosadName] = React.useState("");
  const [codeMosad, setCodeMosad] = React.useState("");
  const [city, setCity] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [classesLearnMishna, setClassesLearnMishna] = React.useState<string[]>(
    []
  );
  const [countOfStudent, setCountOfStudent] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState("");
  const [errors, setErrors] = React.useState({
    email: "",
    phone: "",
    mosadName: "",
    codeMosad: "",
    city: "",
    firstName: "",
    lastName: "",
    classesLearnMishna: "",
    countOfStudent: "",
  });
  const [selectOpen, setSelectOpen] = React.useState(false); // State to control the open state of the Select

  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      email: "",
      phone: "",
      mosadName: "",
      codeMosad: "",
      city: "",
      firstName: "",
      lastName: "",
      classesLearnMishna: "",
      countOfStudent: "",
    };

    if (!validateEmail(email)) {
      newErrors.email = "אנא הכנס כתובת מייל תקינה.";
      valid = false;
    }

    if (!phone) {
      newErrors.phone = "אנא הכנס מספר טלפון.";
      valid = false;
    }

    if (!mosadName) {
      newErrors.mosadName = "אנא הכנס שם המוסד.";
      valid = false;
    }

    if (!codeMosad) {
      newErrors.codeMosad = "אנא הכנס קוד המוסד.";
      valid = false;
    }

    if (!city) {
      newErrors.city = "אנא הכנס עיר.";
      valid = false;
    }

    if (!firstName) {
      newErrors.firstName = "אנא הכנס שם פרטי.";
      valid = false;
    }

    if (!lastName) {
      newErrors.lastName = "אנא הכנס שם משפחה.";
      valid = false;
    }

    if (classesLearnMishna.length === 0) {
      newErrors.classesLearnMishna = "אנא בחר כיתות לומדות משנה.";
      valid = false;
    }

    if (!countOfStudent) {
      newErrors.countOfStudent = "אנא הכנס מספר התלמידים.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(""); // Reset any previous errors

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axios.post(
        "https://shanenli-server.fly.dev/school-register",
        {
          email,
          phone,
          mosad_name: mosadName,
          code_mosad: codeMosad,
          city,
          first_name: firstName,
          last_name: lastName,
          classes_learn_mishna: classesLearnMishna,
          count_of_student: countOfStudent,
        }
      );

      if (response.status === 200) {
        setSubmitted(true);
        setEmail("");
        setPhone("");
        setMosadName("");
        setCodeMosad("");
        setCity("");
        setFirstName("");
        setLastName("");
        setClassesLearnMishna([]);
        setCountOfStudent("");
        setErrors({
          email: "",
          phone: "",
          mosadName: "",
          codeMosad: "",
          city: "",
          firstName: "",
          lastName: "",
          classesLearnMishna: "",
          countOfStudent: "",
        });

        setTimeout(() => {
          handleClose();
        }, 3000); // Close the modal after 3 seconds
      }
    } catch (error) {
      setError("אירעה שגיאה בהגשת הפרטים. אנא נסה שוב.");
    }
  };

  const classesOptions = [
    "א",
    "ב",
    "ג",
    "ד",
    "ה",
    "ו",
    "ז",
    "ח",
    "ט",
    "י",
    "יא",
    "יב",
  ];

  const handleClassChange = (event: SelectChangeEvent<string | string[]>) => {
    setClassesLearnMishna(event.target.value as string[]);
  };

  const handleClassClose = () => {
    setSelectOpen(false);
    setErrors((prevErrors) => ({ ...prevErrors, classesLearnMishna: "" }));
  };

  return (
    <Dialog className="school-register-modal" open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: "center" }}>
        רישום בית הספר למערכת שלנו
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className="close-button"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ maxHeight: "70vh", overflowY: "auto" }}>
        <DialogContentText sx={{ textAlign: "center" }}>
          אנחנו שמחים להציע לך, מנהל בית ספר יקר, את האפשרות לרשום את בית הספר
          שלך למערכת שלנו. על מנת להתחיל את תהליך הרישום בצורה מסודרת, נשמח אם
          תשאיר את פרטי המייל והטלפון שלך, וניצור איתך קשר בהקדם כדי לאסוף את
          שאר הפרטים הנדרשים להשלמת הרישום.
        </DialogContentText>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="mosad_name"
                  label="שם המוסד"
                  name="mosad_name"
                  value={mosadName}
                  onChange={(e) => setMosadName(e.target.value)}
                  error={!!errors.mosadName}
                  helperText={errors.mosadName}
                  size="small"
                />
              </Box>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="code_mosad"
                  label="קוד המוסד"
                  name="code_mosad"
                  value={codeMosad}
                  onChange={(e) => setCodeMosad(e.target.value)}
                  error={!!errors.codeMosad}
                  helperText={errors.codeMosad}
                  size="small"
                />
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="city"
                  label="עיר"
                  name="city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  error={!!errors.city}
                  helperText={errors.city}
                  size="small"
                />
              </Box>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="count_of_student"
                  label="מספר התלמידים"
                  name="count_of_student"
                  value={countOfStudent}
                  onChange={(e) => setCountOfStudent(e.target.value)}
                  error={!!errors.countOfStudent}
                  helperText={errors.countOfStudent}
                  size="small"
                />
              </Box>
            </Box>
            
            <Box>
              <FormControl
                fullWidth
                margin="normal"
                error={!!errors.classesLearnMishna}
              >
                <InputLabel id="classes_learn_mishna-label">
                  כיתות לומדות משנה
                </InputLabel>
                <Select
                  labelId="classes_learn_mishna-label"
                  id="classes_learn_mishna"
                  multiple
                  inputProps={{ 'aria-label': 'כיתות לומדות משנה' }}
                  value={classesLearnMishna}
                  onChange={handleClassChange}
                  open={selectOpen}
                  onClose={handleClassClose}
                  onOpen={() => setSelectOpen(true)}
                  renderValue={(selected) => selected.join(", ")}
                  size="small"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 224,
                      },
                    },
                  }}
                >
                  {classesOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Checkbox checked={classesLearnMishna.indexOf(option) > -1} />
                      <ListItemText primary={option} />
                    </MenuItem>
                  ))}
                </Select>
                <ListSubheader>
                  <Button
                    onClick={handleClassClose}
                    color="primary"
                    sx={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                    }}
                  >
                    אישור
                  </Button>
                </ListSubheader>
                {errors.classesLearnMishna && (
                  <Alert severity="error">{errors.classesLearnMishna}</Alert>
                )}
              </FormControl>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="first_name"
                  label="שם פרטי"
                  name="first_name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  size="small"
                />
              </Box>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="last_name"
                  label="שם משפחה"
                  name="last_name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  size="small"
                />
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="כתובת מייל"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!errors.email}
                  helperText={errors.email}
                  size="small"
                />
              </Box>
              <Box sx={{ flex: '1 1 45%', minWidth: '200px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="phone"
                  label="מספר טלפון"
                  name="phone"
                  autoComplete="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  size="small"
                />
              </Box>
            </Box>
          </Box>
          {submitted && (
            <Alert severity="success">
              אנו ניצור קשר אתכם בהקדם, לשמוע על האתגרים והצרכים שלכם בתחום
              הקריאה, השינון ולימוד בעל פה
            </Alert>
          )}
          {error && <Alert severity="error">{error}</Alert>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit}
          color="primary"
          sx={{
            border: "1px solid #1976d2",
          }}
        >
          שלח
        </Button>
        <Button
          onClick={handleClose}
          color="primary"
          sx={{
            border: "1px solid #1976d2",
            marginLeft: "10px",
          }}
        >
          ביטול
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SchoolRegisterFormModal;